<div fxFlex fxLayout="column" fxLayoutGap="10px">

  <!-- LOGO -->
  <!-- <div fxFlex style="border: 1px dotted #ddd;border-radius: 5px;padding: 15px 10px;" fxLayout="column"
    fxLayoutGap="10px">
    <div *ngIf="imageVisible" fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
      <span style="padding-top: 16px;" fxFlex.gt-md="10">Categroy Image</span>
      <div fxFlex.gt-md="10">
        <img style="height: 50px;
width: auto;" [src]="serverPath+value" onerror="this.src='assets/images/logo/no-image.png';" alt="">
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button [attr.guide]="'image-btn-1-1' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>Upload</button>

        <button [attr.guide]="'image-btn-2-1' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage(index)" mat-raised-button>delete</button>
      </div>
    </div>

    <div *ngIf="!imageVisible&&!imageDelete" fxLayout="row" fxLayoutAlign="space-between center">
      <calsoft-common-file-upload (fileUploadResult)=getResult($event) [type]="'home'">
      </calsoft-common-file-upload>
      <div>
        <button [attr.guide]="'image-btn-3-1' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
      </div>
    </div>

  </div>

</div> -->


<div *ngIf="imageVisible" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <div fxLayout="column">
    <span>Figure</span>
    <div (click)="getImagedata(serverPath+value)">
      <!-- <img style="height: 50px; width: auto;"  [src]="serverPath+value" onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->
      <calsoft-common-images [src]="serverPath+value" [height]="'50px'" [width]="'auto'" [alt]="">
      </calsoft-common-images>
    </div>
    </div>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button [attr.guide]="'image-btn-4' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>Upload</button>

    <button [attr.guide]="'image-btn-5' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage(index)" mat-raised-button>delete</button>
  </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <calsoft-common-file-upload (fileUploadResult)=getResult($event) [type]="'home'">
  </calsoft-common-file-upload>
  <button [attr.guide]="'image-btn-6' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
</div>